<template>
    <div style="width: 100%; display: flex; height: 100vh; overflow: hidden;">
        <!-- 左侧菜单 -->
        <div style="width: 15%; border-right: 1px solid #e6e6e6; background: #fff; overflow-y: auto;">
            <el-row style="margin-top: 2vh; padding: 20px;">
                <el-col :span="24">
                    <div class="parent-warehouse-item" v-for="warehouse in filteredParentWarehouses" :key="warehouse.id"
                        :class="{ 'active': currentParentId === warehouse.id }"
                        @click="handleParentWarehouseClick(warehouse)">
                        <span class="parent-warehouse-name" style="color: #000;">{{ warehouse.name }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 右侧内容 -->
        <div class="page-container">
            <!-- 图表区域 -->
            <div v-if="currentParentId === 2" class="charts-container">
                <el-row style="padding: 0 20px; margin-top: 20px;">
                    <el-col :span="24">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline">
                            <el-form-item label="功能间">
                                <el-select v-model="formInline.froomId" placeholder="选择功能间" filterable clearable
                                    style="width: 220px;">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="room in roomList" :key="room.id" :label="room.name"
                                        :value="room.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit()">查询</el-button>
                                <el-button @click="resetSearch()">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>

                <el-row :gutter="30" style="margin-top: 10px; padding: 0 20px;">
                    <el-col :span="24">
                        <el-card class="chart-card">
                            <div slot="header">
                                水电气能耗趋势
                                <span v-if="currentRoomName"> - {{ currentRoomName }}</span>
                            </div>
                            <div class="chart-wrapper">
                                <ChartsView1 :time="dateTime" :water="chartWater" :electric="chartElectric"
                                    :gas="chartGas" />
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>

            <!-- 设备列表区域 -->
            <div v-else>
                <el-row style="margin-top: 2vh; padding: 0 20px;">
                    <el-col :span="24">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline">
                            <el-form-item label="设备名称">
                                <el-input v-model="formInline.deviceName" placeholder="设备名称"></el-input>
                            </el-form-item>
                            <el-form-item label="功能间">
                                <el-select v-model="formInline.froomId" placeholder="选择功能间" filterable clearable
                                    style="width: 200px;">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="room in roomList" :key="room.id" :label="room.name"
                                        :value="room.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit()">查询</el-button>
                                <el-button @click="resetSearch()">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>

                    <el-col :span="24" class="card-container-wrapper">
                        <div class="card-container">
                            <el-row :gutter="20">
                                <el-col v-for="(item, index) in filteredExamples"
                                    :key="item.deviceSerialnumber || item.id" class="card-item">
                                    <el-card class="room-card"
                                        :class="['device-card', index % 2 === 0 ? 'card-even' : 'card-odd']"
                                        shadow="hover">
                                        <div class="card-body">
                                            <div class="device-image">
                                                <img :src="item.photoUrl" :alt="item.deviceName + '图片'"
                                                    class="device-photo" />
                                            </div>
                                            <div class="device-info">
                                                <p><i class="el-icon-home"></i>设备名称: {{ item.deviceName }}</p>
                                                <p><i class="el-icon-home"></i>电流: {{ item.current || '暂无数据' }}</p>
                                                <p><i class="el-icon-home"></i>功能间: {{ item.froom }}</p>
                                                <p><i class="el-icon-user"></i> 生产厂家: {{ item.manufacturer || '无' }}</p>
                                                <p><i class="el-icon-user"></i> 设备型号: {{ item.deviceModel || '无' }}</p>
                                                <p><i class="el-icon-menu"></i> 设备序列号: {{ item.deviceSerialnumber }}</p>
                                                <p><i class="el-icon-user"></i> 更新时间: {{ item.time || item.updateTime ||
                                                    '暂无' }}</p>
                                            </div>
                                            <div class="card-actions">
                                                <el-button size="mini" @click="openDetailDrawer(item)" type="primary"
                                                    icon="el-icon-picture">详情</el-button>
                                            </div>
                                        </div>
                                    </el-card>
                                </el-col>
                            </el-row>
                            <el-empty v-if="filteredExamples.length === 0" description="暂无设备数据"></el-empty>
                        </div>

                        <div class="pagination-container">
                            <el-pagination align="center" @size-change="handleSizeChange"
                                @current-change="handleCurrentChange" :current-page="currentPage"
                                :page-sizes="[4, 8, 16, 32]" :page-size="pageSize" background
                                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- 新增弹窗 -->
            <el-dialog title="新增设备" :visible.sync="addModalVisible" width="600px" :close-on-click-modal="false"
                custom-class="device-modal" :modal-append-to-body="false" :append-to-body="true">
                <el-form ref="addForm" :model="addForm" :rules="deviceRules" label-width="120px" class="device-form">
                    <el-form-item label="设备名称" prop="deviceName">
                        <el-input v-model="addForm.deviceName" placeholder="请输入设备名称"></el-input>
                    </el-form-item>
                    <el-form-item label="设备序列号" prop="deviceSerialnumber">
                        <el-input v-model="addForm.deviceSerialnumber" placeholder="请输入设备序列号"></el-input>
                    </el-form-item>
                    <el-form-item label="功能间" prop="froomId">
                        <el-select v-model="addForm.froomId" placeholder="选择功能间">
                            <el-option v-for="room in roomList" :key="room.id" :label="room.name"
                                :value="room.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生产厂家" prop="manufacturer">
                        <el-input v-model="addForm.manufacturer" placeholder="请输入生产厂家"></el-input>
                    </el-form-item>
                    <el-form-item label="设备型号" prop="deviceModel">
                        <el-input v-model="addForm.deviceModel" placeholder="请输入设备型号"></el-input>
                    </el-form-item>
                    <el-form-item label="电流值" prop="current">
                        <el-input v-model="addForm.current" placeholder="请输入电流值（如2.5A）"></el-input>
                    </el-form-item>
                    <el-form-item label="设备图片">
                        <el-upload class="upload-demo" action="#" :auto-upload="false" :on-change="handleImageChange"
                            :file-list="addFileList" list-type="picture-preview">
                            <el-button size="small" type="primary">选择图片</el-button>
                            <div slot="tip" class="el-upload__tip">支持JPG/PNG格式，大小不超过2MB</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addModalVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitAddForm()">确定</el-button>
                </div>
            </el-dialog>

            <!-- 详情抽屉 -->
            <el-drawer title="设备详情" :visible.sync="detailDrawerVisible" placement="right" size="60%"
                :close-on-click-modal="false" :append-to-body="true" custom-class="detail-drawer">
                <el-tabs v-model="activeTab" class="detail-tabs" :stretch="true">
                    <el-tab-pane label="基础信息" name="basic">
                        <div class="detail-container" style="padding-left:20px;box-sizing: border-box;">
                            <div class="detail-header">
                                <h2 class="device-name">{{ currentDevice.deviceName || currentDevice.name }}</h2>
                                <el-tag :type="currentDevice.status === '正常' ? 'success' : 'warning'" size="small">
                                    {{ currentDevice.status || '未知状态' }}
                                </el-tag>
                            </div>
                            <div class="detail-image">
                                <img :src="currentDevice.photoUrl"
                                    :alt="(currentDevice.Name || currentDevice.name) + '大图'" class="device-big-photo" />
                            </div>
                            <el-table :data="detailTableData" border :show-header="false" class="detail-table"
                                style="margin-top: 20px;">
                                <el-table-column prop="label" width="120" align="center"></el-table-column>
                                <el-table-column prop="value" align="left"></el-table-column>
                            </el-table>
                            <div class="detail-actions" style="margin-top: 30px; text-align: right;">
                                <el-button @click="detailDrawerVisible = false">关闭</el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { getDeviceList, getAllFeeList } from '@/api/functiondata';
import { getRoomList } from "@/api/function";
import ChartsView1 from '@/components/Chart/ChartsView1.vue';

const mockParentDevices = [
    { id: 1, name: "设备", code: "LYG001", location: "设备" },
    { id: 2, name: "功能间数据", code: "BX002", location: "功能间数据" },
];

// 格式化日期为 YYYY-MM-DD
function formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

export default {
    components: { ChartsView1 },
    data() {
        return {
            parentWarehouses: [],
            filteredParentWarehouses: [],
            currentParentId: null,
            examples: [],
            formInline: { deviceName: '', froomId: '' },
            currentPage: 1,
            pageSize: 8,

            dateTime: [],
            chartWater: [],
            chartElectric: [],
            chartGas: [],

            addModalVisible: false,
            detailDrawerVisible: false,
            activeTab: 'basic',
            currentDevice: {},
            addForm: {
                deviceName: '',
                deviceSerialnumber: '',
                manufacturer: '',
                deviceModel: '',
                froomId: '',
                current: '',
                parentId: ''
            },
            addFileList: [],
            roomList: [],
            loading: false,
            deviceRules: {
                deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
                deviceSerialnumber: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }],
                manufacturer: [{ required: true, message: '请输入设备品牌', trigger: 'blur' }],
                deviceModel: [{ required: true, message: '请输入设备型号', trigger: 'blur' }],
                froomId: [{ required: true, message: '请选择功能间', trigger: 'change' }],
                current: [{ required: true, message: '请输入电流值', trigger: 'blur' }]
            }
        };
    },
    computed: {
        filteredData() {
            return this.examples.filter(item => {
                const nameMatch = (item.deviceName || '').toLowerCase().includes(this.formInline.deviceName.toLowerCase());
                const roomMatch = !this.formInline.froomId || item.roomId === this.formInline.froomId;
                return nameMatch && roomMatch;
            });
        },
        filteredExamples() {
            return this.filteredData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
        },
        total() {
            return this.filteredData.length;
        },
        currentRoomName() {
            if (!this.formInline.froomId) return '';
            const room = this.roomList.find(item => item.id === this.formInline.froomId);
            return room ? room.name : '';
        }
    },
    watch: {
        currentParentId() {
            this.currentPage = 1;
            this.getList();
        }
    },
    async mounted() {
        await this.loadRoomList();
        this.loadParentDevices();

        // 从URL获取roomName并自动选中功能间
        const roomName = this.$route.query.roomName;
        if (roomName && this.roomList.length) {
            const target = this.roomList.find(item => item.name === roomName);
            if (target) {
                this.formInline.froomId = target.id;
                this.onSubmit();
            }
        }
    },
    methods: {
        async loadRoomList() {
            try {
                this.loading = true;
                const { data } = await getRoomList({ userId: localStorage.getItem('userId') || '' });
                this.roomList = (data?.list || data || []).map(room => ({
                    id: room.id || room.roomId,
                    name: room.name || room.roomName
                }));
            } catch (err) {
                console.error(err);
            } finally {
                this.loading = false;
            }
        },

        // 已加入 最近10天 startDate endDate
        async getChartData() {
            try {
                const params = {};
                if (this.formInline.froomId) {
                    const selectedRoom = this.roomList.find(item => item.id === this.formInline.froomId);
                    if (selectedRoom) params.room = selectedRoom.name;
                }

                // 最近 10 天
                const now = new Date()
                const endDate = formatDate(now)
                const startDate = formatDate(new Date(now.getTime() - 10 * 86400 * 1000))

                params.startDate = startDate
                params.endDate = endDate

                const { data } = await getAllFeeList(params);
                const list = data || [];
                if (list.length === 0) return;

                this.dateTime = list[0].dateTime || []
                this.chartWater = list[0].waterConsumption || []
                this.chartElectric = list[0].electricityConsumption || []
                this.chartGas = list[0].gas || []

            } catch (err) {
                console.error('图表数据请求失败', err);
            }
        },

        async getList() {
            if (this.currentParentId === 2) {
                this.getChartData();
                return;
            }
            this.loading = true;
            try {
                const { data } = await getDeviceList({
                    userId: localStorage.getItem('userId') || '',
                    roomId: this.formInline.froomId
                });
                this.examples = (data || []).map(item => ({
                    id: item.id || item.deviceSerialnumber,
                    deviceName: item.deviceName || '未命名',
                    deviceSerialnumber: item.deviceSerialnumber || item.serialNumber || '无',
                    current: item.current || '0A',
                    froom: this.roomList.find(r => r.id === item.roomId)?.name || '未知',
                    roomId: item.roomId,
                    photoUrl: item.photoUrl,
                    manufacturer: item.manufacturer || '无',
                    deviceModel: item.deviceModel || '无',
                    status: item.status || '正常',
                    time: item.updateTime || item.time || ''
                }));
            } catch (err) {
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
        resetSearch() {
            this.formInline = { deviceName: '', froomId: '' };
            this.currentPage = 1;
            this.getList();
        },
        onSubmit() {
            this.currentPage = 1;
            this.getList();
        },
        openAddModal() {
            this.addModalVisible = true;
            this.addForm = { parentId: this.currentParentId, froomId: '' };
            this.addFileList = [];
            this.$nextTick(() => this.$refs.addForm?.resetFields());
        },
        handleImageChange(file, fileList) {
            this.addFileList = fileList;
        },
        submitAddForm() {
            this.$refs.addForm.validate(valid => {
                if (!valid) return;
                this.examples.unshift({
                    ...this.addForm,
                    froom: this.roomList.find(r => r.id === this.addForm.froomId)?.name,
                    status: '正常',
                    time: new Date().toLocaleString()
                });
                this.addModalVisible = false;
                this.$message.success('新增成功');
            });
        },
        openDetailDrawer(item) {
            this.currentDevice = { ...item };
            this.detailDrawerVisible = true;
            this.detailTableData = [
                { label: '设备名称', value: item.deviceName },
                { label: '序列号', value: item.deviceSerialnumber },
                { label: '电流', value: item.current },
                { label: '功能间', value: item.froom },
                { label: '厂家', value: item.manufacturer },
                { label: '型号', value: item.deviceModel },
                { label: '更新时间', value: item.time }
            ];
        },
        goToEdit() {
            this.detailDrawerVisible = false;
            this.$message.info('编辑功能已保留扩展位');
        },
        loadParentDevices() {
            this.parentWarehouses = mockParentDevices;
            this.filteredParentWarehouses = [...mockParentDevices];
            this.currentParentId = mockParentDevices[0]?.id;
            this.getList();
        },
        handleParentWarehouseClick(warehouse) {
            this.currentParentId = warehouse.id;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        }
    }
};
</script>

<style lang="scss" scoped>
.room-card {
    height: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    transition: all 0.3s;

    &:hover {
        transform: translateY(-5px);
    }
}

.charts-container {
    padding: 20px;
    height: 100%;
}

.chart-card {
    height: 100%;
}

.chart-wrapper {
    width: 100%;
    height: 67vh;
    padding: 10px 0;
}

.parent-warehouse-item {
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background: #f5f7fa;
    }

    &.active {
        background: #e6f7ff;
        border-left: 3px solid #1890ff;
    }
}

.page-container {
    width: 85%;
    height: 100vh;
    background: #f5f7fa;
    padding-bottom: 80px;
}

.card-container-wrapper {
    flex: 1;
}

.card-container {
    margin-top: 20px;
    max-height: calc(100vh - 20vh);
    overflow-y: auto;
    padding: 0 20px 20px;
}

.card-item {
    width: 25%;
    margin-bottom: 20px;
}

.device-card {
    height: 100%;
    background: #fff;
    transition: all 0.3s;
}

.card-body {
    padding: 15px;
    display: flex;
    flex-direction: column;
}

.device-image {
    width: 90%;
    height: 260px;
    margin: 0 auto 15px;
    border-radius: 4px;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.device-info {
    font-size: 13px;
    color: #666;
}

.pagination-container {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 20px 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.card-even {
    border-top: 3px solid #409EFF;
}

.card-odd {
    border-top: 3px solid #67C23A;
}
</style>